import * as yup from 'yup';

export const StudyInformationSchema = (t: any) =>
  yup.object({
    educationId: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required(t('formErrors.required')),
    fieldOfStudyId: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required(t('formErrors.required')),
  });
